import React, { Component } from "react";
import { Field, FieldArray, FormSection } from "redux-form";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DescriptionIcon from '@material-ui/icons/Description';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Button, ButtonGroup, Input, Switch } from "@material-ui/core";
import { FileUpload } from "primereact/fileupload";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Calendar } from 'primereact/calendar';
import "./form.css";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import { Rating } from "primereact/rating";
import { AutoComplete } from "primereact/autocomplete";

import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';

import NumberFormat from 'react-number-format';

import { InputTextarea } from "primereact/inputtextarea";

import { TRATAMIENTO_DATOS, TRATAMIENTO_DATOSFinal } from "./contants";

import { Panel } from 'primereact/panel';
import { TextInputCharacter, OnlyTextInput, TextInputRazonSocialCharacter, TextInputNamesCharacter, MultipleSelector } from "./componetsPropios";
import { ENABLED_FROM_BANDEJA, ENABLED_FROM_BANDEJA_STATIC } from "../../pages/empresas/constants";

import { withStyles } from '@material-ui/core/styles';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#000',
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",//theme.shadows[1],
    fontSize: 11,
    textAlign: "justify",
    border: "2px solid #41c40d",
    'font-weight': 'bold',
  },
}))(Tooltip);

export default class MaterialUiForm extends Component {
  constructor(props) {
    super(props);
    this.uploadBan = true;
    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm'
    }

    this.dateHoy = new Date();
    this.activeFormRya = props.activeFormRya;

    this.state = {
      countries: [],
      selectedCountry1: "",
      filteredCountries: null,
      filteredItems: null,
      selectedCountries: "",
      value: '',
      number: "",
      selectOptionsMultiple: [],
      cleanSelection: false,
      stateAfilia: [],

    };
    this.searchCountry = this.searchCountry.bind(this);
    this.handleChangeSelectMultiple = this.handleChangeSelectMultiple.bind(this);

  }

  handleChangeSelectMultiple = (event) => {

    const value = event.target.value;
    const estados = this.state.stateAfilia;
    let newValue = value;
    if (value && value.length > 0 && value.find(e => e === "TODOS")) {
      newValue = estados;
    } else if (value && value.length > 0 && !value.find(e => e === "TODOS") && this.state.selectOptionsMultiple.length > 0 && this.state.selectOptionsMultiple.find(e => e === "TODOS")) {
      newValue = [];
    } else {
      newValue = value;
    }

    this.setState({ selectOptionsMultiple: newValue, cleanSelection: false });

  };

  handleChangeSelectMultipleCatalog = (event) => {

    const value = event.target.value;
    const estados = this.state.stateAfilia;
    let newValue = value;


    // if (value && value.length > 0  && this.state.selectOptionsMultiple.length > 0 && this.state.selectOptionsMultiple.find(e => e === "TODOS")) {
    //   newValue = [];
    // } else {
    //   newValue = value;
    // }

    this.setState({ selectOptionsMultiple: newValue, cleanSelection: false });

  };

  MenuProps = () => {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;

    return {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };
  }

  renderTextJura = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => {


    return (
      <div className={"card-content-jura"}>
        <Panel >
          {custom.options.length > 0 ?
            custom.options.map(item => {
              return (<p>{item}</p>);
            })
            : ""}
        </Panel>
      </div>
    )
  };

  renderCardText = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => {

    return (
      <div className={"card-content-anexo"}>
        {/* <h5>{placeholder}</h5> */}
        <Panel header={placeholder} toggleable collapsed>
          {custom.options.length > 0 ?
            custom.options.map(item => {
              return (<p>{item}</p>);
            })
            : ""}
        </Panel>
      </div>
    )
  };

  renderTypeNumber = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => {

    return (
      <FormControl error={touched && !!error}>

        <NumberFormat
          prefix="$ "
          customInput={TextField}
          thousandSeparator={true}
          inputMode="numeric"
          id={input.name}
          allowNegative={false}
          allowLeadingZeros={false}
          value={input.value}
          inputProps={{ maxLength: custom.maxLength, minLength: custom.minLength }}
          disabled={custom.disabled}
          error={error ? true : false}
          label={placeholder}
          name={input.name}
          {...input}

        />
        {this.renderFromHelper({ touched, error })}

      </FormControl>

    )
  };


  renderTypeNumberNorm = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => {
    const formatNumber = (val) => {

      if (val > 0) {
        return `${parseInt(val)}`;
      }
      return '';
    };
    return (
      <FormControl error={touched && !!error}>

        <NumberFormat
          customInput={TextField}
          thousandSeparator={false}
          inputMode="numeric"
          allowNegative={false}
          format={formatNumber}
          allowLeadingZeros={false}
          id={input.name}
          value={input.value}
          inputProps={{ maxLength: custom.maxLength, minLength: custom.minLength }}
          disabled={custom.disabled}
          error={error ? true : false}
          label={placeholder}
          name={input.name}

          {...input}

        />


        {this.renderFromHelper({ touched, error })}

      </FormControl>

    )
  };


  renderTextArea = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <FormControl error={touched && !!error}>

      <InputTextarea
        autoResize
        id={input.name}
        disabled={custom.disabled}
        placeholder={placeholder}
        {...input}
        {...custom}

      />
      {this.renderFromHelper({ touched, error })}
      <div></div>
    </FormControl>

  );

  renderInputLabel = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => {
    const salto = placeholder?.split("$");
    return (
      <div className="labelIns">

        {salto.length > 1 ?
          <InputLabel className="labelInstruccion">
            {salto.map(e => {
              return (
                <React.Fragment>
                  <br />
                  {e}
                </React.Fragment>);
            })}
          </InputLabel>
          :
          <InputLabel className="labelInstruccion">
            {custom?.options?.length > 0 ? <p className="labelNor"> <p className="labelNeg"> {custom.options[0]}</p> {placeholder} </p> : placeholder}
          </InputLabel>
        }
      </div>
    )
  };

  renderInputLabel2 = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <div className="labelIns">

      <InputLabel className="labelInstruccion">
        {
          custom.options.length > 0 ?
            custom.options.map(item => {
              return (<p>{item}</p>);
            })
            : ""
        }
      </InputLabel>
    </div>
  );



  renderCalendar = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => {
    return (
      <React.Fragment>
        <Calendar
          label={placeholder}
          id={input.name}
          disabled={custom.disabled}
          error={error ? true : false}
          locale={this.es}
          placeholder={"yyyy-mm-dd"}
          dateFormat={"yy-mm-dd"}
          maxDate={this.dateHoy}
          readOnlyInput
          monthNavigator
          yearNavigator
          yearRange="1900:2100"
          showIcon

          value={input.value}
          {...input}
          {...custom}

        />
        {this.renderFromHelper({ touched, error })}
      </React.Fragment>
    )
  };

  renderCalendarV2 = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <div>
      <Calendar
        label={placeholder}
        id={input.name}
        disabled={custom.disabled}
        error={error ? true : false}
        readOnlyInput
        locale={this.es}
        placeholder={"yyyy-mm"}
        view={"month"}
        yearNavigator
        yearRange="1900:2100"
        dateFormat={"yy-mm"}
        showIcon
        {...input}
        {...custom}

      ></Calendar>
      {this.renderFromHelper({ touched, error })}
    </div>
  );

  renderTextFieldEmail = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <div>
      <TextField
        label={placeholder}
        data-title={custom.dataTitle}
        id={input.name}
        onPaste={(e) => {
          e.preventDefault()
          return false;
        }}
        onCopy={(e) => {
          e.preventDefault()
          return false;
        }}
        disabled={custom.disabled}
        error={error ? true : false}
        inputProps={{ maxLength: custom.maxLength, minLength: custom.minLength }}
        //helpertext={touched && error}
        placeholder={placeholder}
        {...input}
        {...custom}
      />
      {this.renderFromHelper({ touched, error })}
    </div>
  );

  renderTextField = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <div>
      <TextField
        label={placeholder}
        id={input.name}
        disabled={custom.disabled}
        error={error ? true : false}
        inputProps={{ maxLength: custom.maxLength, minLength: custom.minLength }}
        //helpertext={touched && error}
        placeholder={placeholder}
        {...input}
        {...custom}
      />
      {this.renderFromHelper({ touched, error })}
    </div>
  );

  onChange = (e) => {
    const newValue = e.target.value;

    if (newValue.match(/^[A-Za-z0-9\s]+$/) || newValue.length === 0) {
      this.setState({ value: newValue }); // only set when successful
    }
  };

  renderOnlyTextInput = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <React.Fragment>
      <OnlyTextInput
        placeholder={placeholder}
        name={input.name}
        {...input}
        {...custom}
        touched={touched}
        error={error}
      />

      {this.renderFromHelper({ touched, error })}
    </React.Fragment>
  );




  renderTextInputCharacter = ({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <React.Fragment>
      <TextInputCharacter
        placeholder={placeholder}
        name={input.name}
        {...input}
        {...custom}
        touched={touched}
        error={error}
      />

      {this.renderFromHelper({ touched, error })}
    </React.Fragment>
  );

  renderTextInputRazonCharacter = (props) => {
    return (
      <TextInputRazonSocialCharacter
        {...props}
      />
    )
  };

  renderTextInputNamesCharacter = (props) => {
    return (
      <TextInputNamesCharacter
        {...props}
      />
    )
  };

  renderTextDireccion = ({
    label,
    input,
    placeholder,
    modalDireccion,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <div>
      <TextField
        label={placeholder}
        id={input.name}
        disabled={this.activeFormRya ? this.activeFormRya : custom.disabled}
        error={error ? true : false}
        inputProps={{ maxLength: custom.maxLength, minLength: custom.minLength, readOnly: true, }}
        //helpertext={touched && error}
        onClick={() => this.activeFormRya ? "" : custom.options[0].modalDireccion({ name: input.name })}
        placeholder={placeholder}
        {...input}
        {...custom}
      />
      {this.renderFromHelper({ touched, error })}
    </div>
  );

  renderSrc = ({ input, meta: { touched, error, invalid }, label }) => (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
          />
        }
      />
      {this.renderFromHelper({ touched, error })}
    </div>
  );
  renderLinkGe = ({ input, meta: { touched, error, invalid }, label, ...custom }) => (
    <div>
      <div className="checkHabeas">
        <FormControlLabel
          control={
            <Checkbox
              checked={input.value ? true : false}
              onChange={input.onChange}
              disabled={custom.disabled}
            />
          }
          label={
            <p className="datosAutorizo">
              {custom.placeholder}
              <Link
                // color=""
                onClick={() => {
                  window.open(
                    "https://www.comfenalcovalle.com.co/corporativo/quienes-somos/politica-de-tratamiento-de-la-informacion"
                  );
                }}
              >
                {custom.options[0].length > 0 ? custom.options[0] : ""}
              </Link>
              {"*"}
            </p>
          }
        />
      </div>
      {this.renderFromHelper({ touched, error })}
    </div>
  );
  renderLink = ({ input, meta: { touched, error, invalid }, label, ...custom }) => (
    <div>
      <div className="checkHabeas">
        <FormControlLabel
          control={
            <Checkbox
              checked={input.value ? true : false}
              onChange={input.onChange}
              disabled={custom.disabled}
            />
          }
          label={
            <p className="datosAutorizo">
              {TRATAMIENTO_DATOS}
              <Link
                // color=""
                onClick={() => {
                  window.open(
                    "https://www.comfenalcovalle.com.co/corporativo/quienes-somos/politica-de-tratamiento-de-la-informacion"
                  );
                }}
              >
                {" "}
                política de tratamiento{" "}
              </Link>
              {TRATAMIENTO_DATOSFinal}
            </p>
          }
        />
      </div>
      {this.renderFromHelper({ touched, error })}
    </div>
  );
  renderCheckbox = ({ input, meta: { touched, error, invalid }, label, placeholder }) => (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
          />
        }
        label={placeholder}
      />
      {this.renderFromHelper({ touched, error })}
    </div>
  );

  renderRnecCheckbox = ({ input, meta: { touched, error, invalid }, ...custom }) => (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checkedIcon={this.props.validRnecRepLegal ? <CheckCircleIcon className="sucess-rnec" /> : <RemoveCircleIcon className="fail-rnec" />}
            checked={true}
          />
        }
        label={this.props.validRnecRepLegal ? " VALIDADO POR RNEC" : "ACTUALIZACIÓN RNEC PENDIENTE"}
      />
      {this.renderFromHelper({ touched, error })}
    </div>
  );

  radioButton = ({ input, meta: { touched, error, invalid }, children, ...rest }) => {
    const { options, key } = rest;

    return (
      <FormControl >
        <RadioGroup {...children} {...input} {...rest}>
          {options.map((item, ri) => {
            return (
              <FormControlLabel
                //key={`ri-${ri}`}
                value={item.value}
                control={<Radio />}
                label={item.label}
                checked={item.value === item.handleRadio ? true : false}
              />
            );
          })}
        </RadioGroup>
        {this.renderFromHelper({ touched, error })}
      </FormControl>
    );
  };
  radioButton2 = ({ input, meta: { touched, error, invalid }, children, ...rest }) => {
    const { options, key } = rest;
    return (
      <FormControl disabled={rest.disabled}>
        <RadioGroup  {...children} {...input} {...rest} >

          {options.map((item, ri) => {
            return (
              <FormControlLabel
                //key={`ri-${ri}`}
                value={item.value}
                control={<Radio />}
                label={item.label}

              //checked={item.value}
              />
            );
          })}
        </RadioGroup>
        {this.renderFromHelper({ touched, error })}
      </FormControl>
    );
  };

  renderFromHelper = ({ touched, error }) => {
    if (!(error)) {
      return;
    } else {
      return <FormHelperText>{true && error}</FormHelperText>;
    }
  };

  renderFromHelperTouched = ({ touched, error, input }) => {
    if (!(error)) {
      return;
    } else {
      return <FormHelperText>{touched && error}</FormHelperText>;
    }
  };

  stateInput = (value) => {
    var sta = ""
    if (value) {
      sta = value;
    }
    return sta;
  }

  renderStarsButton = ({
    input,
    label,
    meta: { touched, error, invalid },
    children,
    ...custom
  }) => (
    <Rating value={1} cancel={false} error={touched && invalid} {...input} />
  );

  renderSwitchButton = ({
    input,
    label,
    meta: { touched, error, invalid },
    children,
    ...custom
  }) => <Switch cancel="medium" error={touched && invalid} {...input} />;



  // filterOptions = createFilterOptions({
  //   matchFrom: 'start',
  //   stringify: (option) => option.label,
  // });

  getSelectedOption = (options, input) => {

    let res = { label: " ", value: "" }
    res = options.find(o => o.label === input) //: "";

    return res;
  }

  searchCountry = (countries, event) => {
    setTimeout(() => {
      let filteredCountries;
      if (!event.query.trim().length) {
        filteredCountries = [...countries];
      } else {
        filteredCountries = countries.filter((country) => {
          return country.label
            .toLowerCase()
            .includes(event.query.toLowerCase());
        });

      }

      this.setState({ filteredCountries });
    }, 50);
  }

  pruebadeevent(e) {
    return this.setState({ selectedCountry1: e.value });
  }

  renderAutocomplete = ({
    input,
    label,
    placeholder,
    meta: { touched, error, invalid },
    children,
    ...custom

  }) => {

    return (
      <React.Fragment>
        <AutoComplete
          value={this.state.selectedCountry1}
          suggestions={this.state.filteredCountries}
          completeMethod={(e) => this.searchCountry(custom.options, e)}
          field="label"
          onChange={(e) => this.setState({ selectedCountry1: e.value })}
          dropdown
          placeholder={placeholder}
          name={input.name}
          {...input}
          {...custom}
          touched={touched}
          error={error}
        />


        {this.renderFromHelper({ touched, error })}
      </React.Fragment>

    )
  };

  renderAutocompleteMultiple = ({
    input,
    label,
    placeholder,
    meta: { touched, error, invalid },
    children,
    ...custom

  }) => {
    console.log(this.state.selectedCountries, `Autocomplete`, input.value)
    if (this.state.selectedCountries !== input.value) {

      input.value = this.state.selectedCountries;
    } else {
      this.setState({ selectedCountries: input.value })
    }

    return (
      <React.Fragment>
        <AutoComplete
          value={input.value}
          suggestions={this.state.filteredCountries}
          completeMethod={(e) => this.searchCountry(custom.options, e)}
          field="label"
          //onChange={(e) => this.setState({ selectedCountries: e.value })}
          dropdown
          multiple={true}
          placeholder={placeholder}
          name={input.name}
          {...input}
          {...custom}
          touched={touched}
          error={error}
        />


        {this.renderFromHelper({ touched, error })}
      </React.Fragment>

    )
  };

  renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <FormControl error={touched && !!error}>
      <InputLabel htmlFor={`${input.name}-native-simple`}>
        {custom.placeholder}
      </InputLabel>

      <Select
        native
        error={error ? true : false}
        {...input}
        {...custom}
        inputProps={{
          name: input.name,
          id: `${input.name}-native-simple`,
          disabled: custom.disabled,
        }}
      >
        {<option key={`option-${input.name}`} value=""></option>}
        {custom.options.map((item, k) => {
          return (
            <option key={`s-option-${k}`} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </Select>
      {/* //</div> */}
      {this.renderFromHelper({ touched, error })}
    </FormControl>
  );

  renderSelectFieldML = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => {
    if (input.value === "clean" && this.state.selectOptionsMultiple.length > 0 && !this.state.cleanSelection) {
      this.setState({ selectOptionsMultiple: [], cleanSelection: true });
      //this.handleChangeSelectMultiple({ target: { value: [] } })
    }

    return (
      <FormControl error={touched && !!error}>
        <InputLabel htmlFor={`${input.name}-native-simple`}>
          {custom.placeholder}
        </InputLabel>

        <Select
          className="select-checkbox"
          multiple
          error={error ? true : false}
          {...input}
          {...custom}
          value={this.state.selectOptionsMultiple}
          onChange={this.handleChangeSelectMultiple}
          inputProps={{
            name: input.name,
            id: `${input.name}-native-simple`,
            disabled: custom.disabled,
          }}
          input={<Input />}
          MenuProps={this.MenuProps}
          renderValue={(selected) => selected !== "clean" && selected.join(", ")}
        >
          {<option key={`option-${input.name}`} value=""></option>}
          {custom.options.map((e, k) => {
            return (
              <MenuItem key={e} value={e}>
                <Checkbox checked={this.state.selectOptionsMultiple.indexOf(e) > -1} />
                <ListItemText primary={e} />
              </MenuItem>
            );
          })}
        </Select>
        {this.renderFromHelper({ touched, error })}
      </FormControl>
    )
  };

  renderSelectFieldMLTWO = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => {
    // if (input.value === "clean" && this.state.selectOptionsMultiple.length > 0 && !this.state.cleanSelection) {
    //   this.setState({ selectOptionsMultiple: [], cleanSelection: true });
    //   //this.handleChangeSelectMultiple({ target: { value: [] } })
    // }

    return (
      <FormControl error={touched && !!error}>
        <InputLabel htmlFor={`${input.name}-native-simple`}>
          {custom.placeholder}
        </InputLabel>

        <Select
          className="select-checkbox"
          multiple
          error={error ? true : false}
          {...input}
          {...custom}
          value={this.state.selectOptionsMultiple}
          onChange={this.handleChangeSelectMultipleCatalog}
          inputProps={{
            name: input.name,
            id: `${input.name}-native-simple`,
            disabled: custom.disabled,
          }}
          input={<Input />}
          MenuProps={this.MenuProps}
          renderValue={(selected) => selected !== "clean" && selected.join(", ")}
        >
          {<option key={`option-${input.name}`} value=""></option>}
          {custom.options.map((e, k) => {
            return (
              <MenuItem key={e.value} value={e.label}>
                <Checkbox checked={this.state.selectOptionsMultiple.indexOf(e.label) > -1} />
                <ListItemText primary={e.label} />
              </MenuItem>
            );
          })}
        </Select>
        {this.renderFromHelper({ touched, error })}
      </FormControl>
    )
  };

  renderSpacer = (customKey) => (
    <div className={"custom-input spacer"} key={customKey} />
  );

  renderParrafo = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <div className={"custom-input parrafo"} key={label}>
      <p>{label}</p>
    </div>
  );

  renderChidlren = ({ fields, meta: { touched, error }, ...props }) => (
    <ul className="form-child">
      {/* {props.label && <h3>{"Integrantes posulados"}</h3>} */}
      {fields &&
        fields.length > 0 &&
        fields.map((member, index) => (

          <li className={`${member}`} key={index}>
            <h4>
              {props.fieldtitle} #{index + 1}
            </h4>
            <MaterialUiForm
              submitable={false}
              items={props.subitems}
              className="field-child"
              member={member}
              dynamicOptions={props.dynamicOptions}
              changeComponentId={props.changeComponentId}
              tamanioFiles={props.tamanioFiles}
              activeFormRya={props.activeFormRya}
              validRnecRepLegal={props.validRnecRepLegal}
              editInfoFromBandeja={props.editInfoFromBandeja}
              validations={props.validations}
              formName={props.formName}
              invalid={props.invalid}
              modalDireccion={props.modalDireccion}
            />

            <div className={`button-wrapper delete `}>
              <div>
              </div>
              <ButtonGroup color="primary" aria-label="primary button group">
                <Button
                  color="secondary"
                  type="button"
                  className="delete"
                  //disabled={props.enableDisableArray? true: false}
                  title={props.removeLabel}
                  onClick={() => {
                    props.handleSuma({ member, index });
                    if (props.enableDisableArray === false || props.enableDisableArray < index) fields.remove(index);
                  }}
                >
                  {props.removeLabel}
                </Button>
              </ButtonGroup>
            </div>
          </li>
        ))}

      <li>
        {props.label ?
          <div className="labelIns">
            <InputLabel className="labelInstruccion"> {props.label}</InputLabel>
          </div>
          : ""}
        <div className="button-wrapper add">
          <ButtonGroup color="primary" aria-label="primary button group">
            <Button
              color="primary"
              type="button"
              className="add"
              title={props.addLabel}
              onClick={fields?.length < 50 ? () => fields.push({}) : ""}
            >
              {props.addLabel}
            </Button>
          </ButtonGroup>
        </div>
        {touched && error && <span>{error}</span>}
      </li>
    </ul>
  );

  render() {
    const {
      items,
      member,
      sectionTitle,
      handleRemove,
      invalid,
      validations,
      dynamicOptions,
      tamanioFiles,
      hiddenClose,
      dynamicDisable,
      activeFormRya,
      validRnecRepLegal,
      editInfoFromBandeja,
      modalDireccion,
      deleteAnexo,
      deleteFirma,
      activateRadio,
      optionsTable,
      rebootFiles,
      formName,
      handleUploadAnexo,
      handleRemoveAnexo,
      handleSeeAnexo,
      nameAnexos,
      newEstado,
      changeComponentId,
    } = this.props;


    return (
      <React.Fragment>
        <div className="field-container">
          {sectionTitle && <h3>{sectionTitle}</h3>}

          {items.map((field, j) => {
            let renderComponent = {};
            const specialName = member ? `${member}.${field.name}` : field.name;
            let fileData = false;
            if (field.typeForm === "file" || field.typeForm === "fileF" || field.typeForm === "fileA") {
              fileData = {
                name: specialName,
                label: field.label,
                formName,
              };
            }

            if (this.state.stateAfilia.length < 1 && dynamicOptions && dynamicOptions.stateAfilia?.length > 0) {
              this.setState({ stateAfilia: dynamicOptions.stateAfilia })
            }

            field.options =
              optionsTable && optionsTable[field.name]
                ? optionsTable[field.name]
                : field.options;

            field.options =
              dynamicOptions && dynamicOptions[field.name]
                ? dynamicOptions[field.name]
                : field.options;

            field.disabled =
              dynamicDisable && dynamicDisable[specialName] !== undefined
                ? dynamicDisable[specialName]
                : field.disabled;

            //cambio de componente
            field.type = changeComponentId && changeComponentId[specialName] !== undefined
              ? changeComponentId[specialName]
              : field.type;

            field.typeForm
              = changeComponentId && changeComponentId[specialName] !== undefined
                ? changeComponentId[specialName]
                : field.typeForm;



            if (activeFormRya) {
              if (ENABLED_FROM_BANDEJA_STATIC.find(e => e === specialName))
                field.disabled = false;
              else
                field.disabled = true;

              if (!validRnecRepLegal && ENABLED_FROM_BANDEJA.find(e => e === specialName)) {
                field.disabled = false;
              }


              if (!this.activeFormRya)
                this.setState({ activeFormRya: activeFormRya })
            }

            if (rebootFiles !== false && rebootFiles !== undefined) {
              if (rebootFiles.name === field.name) {
                field.fields = rebootFiles.fields;
              }
            }

            // field.charged = charged && charged[field.name] ? charged[field.name] : field.charged;
            switch (field.typeForm) {
              case "text":
                renderComponent = this.renderTextField;
                break;
              case "textCharacter":
                renderComponent = this.renderTextInputCharacter;
                break;
              case "onlyText":
                renderComponent = this.renderOnlyTextInput;
                break;
              case "textRazon":
                renderComponent = this.renderTextInputRazonCharacter;
                break;
              case "textNames":
                renderComponent = this.renderTextInputNamesCharacter;
                break;
              case "date":
                renderComponent = this.renderCalendar;
                break;
              case "dateMo":
                renderComponent = this.renderCalendarV2;
                break;
              case "dire":
                renderComponent = this.renderTextDireccion;
                break;
              case "radio":
                renderComponent = this.radioButton;
                break;
              case "radio2":
                renderComponent = this.radioButton2;
                break;
              case "checkbox":
                renderComponent = this.renderCheckbox;
                break;
              case "rnecBox":
                renderComponent = this.renderRnecCheckbox;
                break;
              case "select":
                renderComponent = this.renderSelectField;
                break;
              case "MLTselect":
                renderComponent = this.renderSelectFieldML;
                break;
              case "MLTselectTWO":
                renderComponent = this.renderSelectFieldMLTWO;
                break;
              case "switch":
                renderComponent = this.renderSwitchButton;
                break;
              case "spacer":
                renderComponent = this.renderSpacer;
                break;

              case "parrafo":
                renderComponent = this.renderParrafo;
                break;

              case "array":
                renderComponent = this.renderChidlren;
                break;
              case "stars":
                renderComponent = this.renderStarsButton;
                break;
              case "src":
                renderComponent = this.renderSrc;
                break;
              case "link":
                renderComponent = this.renderLink;
                break;
              case "link2":
                renderComponent = this.renderLinkGe;
                break;
              case "area":
                renderComponent = this.renderTextArea;
                break;
              case "label":
                renderComponent = this.renderInputLabel;
                break;
              case "label2":
                renderComponent = this.renderInputLabel2;
                break;
              case "autocomplete":
                renderComponent = this.renderAutocomplete;
                break;
              case "autocompleteMLT":
                renderComponent = this.renderAutocompleteMultiple;
                break;
              case "numberN":
                renderComponent = this.renderTypeNumber;
                break;
              case "number":
                renderComponent = this.renderTypeNumberNorm;
                break;
              case "cardText":
                renderComponent = this.renderCardText;
                break;
              case "cardJura":
                renderComponent = this.renderTextJura;
                break;
              case "email":
                renderComponent = this.renderTextFieldEmail;
                break;


              default:
                renderComponent = this.renderTextField;
                break;
            }
            return (
              <div
                className={`material-field ${field.hidden ? "no-visible" : ""
                  } ${field.className}`}
                key={j + 'field'}
              >
                {field.typeForm === "instruccion" ? (<React.Fragment>

                  {field.options && field.options.motivo && (
                    <div className="devolucion-form">
                      <p className="encabezado">{field.options.encabezado}</p>
                      <p className="motivo">{`Causa: ${field.options.motivo}`}</p>
                      <p className="observacion">{`Obseravación: ${field.options.observacion}`}</p>
                    </div>
                  )}
                </React.Fragment>)
                  : field.typeForm === "table" ? (
                    <div>
                      <TableContainer component={Paper} className="tableEmpresa">
                        <Table
                          className={"classes.table"}
                          aria-label="simple table"
                        >
                          <TableHead >
                            <TableRow>
                              {field.rows.map((campo) => (
                                <TableCell align="right">{campo}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              {field.options.map((row) => (
                                <TableCell align="right">{row}</TableCell>
                              ))}
                            </TableRow>

                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  ) : field.typeForm === "information" ? (
                    <div className="button-Update">
                      <p className="parrafo-Update">{field.placeholder}</p>
                    </div>

                  ) : field.typeForm === "buttonDownload" ? (

                    <div className="button-download">
                      <Button
                        variant={field.variant}
                        color={"primary"}
                        type={`${field.submitable ? "submit" : "button"}`}
                        className={field.className}
                        startIcon={<GetAppIcon />}
                        onClick={() => window.open(field.options[0])}
                      //onClick={(event) => field.onClick({ field, event })}
                      >{field.placeholder}
                      </Button>
                    </div>

                  ) : field.typeForm === "buttonA" ? (
                    <div>
                      <div className="button-Update">
                        <p className="parrafo-Update">{field.placeholder}</p>
                        <Button
                          variant={field.variant}
                          color={"primary"}
                          type={`${field.submitable ? "submit" : "button"}`}
                          className={field.className}
                          onClick={() => window.open(field.options[0], "Popup", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0,")}
                        >{field.label}
                        </Button>
                      </div>
                    </div>
                  ) : field.typeForm === "buttonX" ? (
                    <div>
                      <div className="button-AddRecurso">
                        <Button
                          variant={field.variant}
                          color={"primary"}
                          type={`${field.submitable ? "submit" : "button"}`}
                          className={field.className}
                          onClick={(event) => field.onClick({ field, event })}
                        //disabled={validations && field.primary ? invalid : false}
                        >{field.placeholder}</Button>
                      </div>
                    </div>
                  ) : field.typeForm === "tableAnexos" ? (
                    <div>
                      <TableContainer component={Paper} className="tableAhorro">
                        <Table
                          className={"classes.table"}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              {field.rows.map((campo) => (
                                campo.includes("ACCION") ?
                                  <TableCell align="right">{campo}</TableCell>
                                  : <TableCell align="right">{campo}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {field.options?.map((row) => (
                              <TableRow >
                                {row?.map((campo) => (

                                  <TableCell align="right">{campo.label}</TableCell>
                                ))}
                                <TableCell align="right">
                                  {
                                    nameAnexos && nameAnexos[row[0].value] && nameAnexos[row[0].value].includes("chargedFileProsses") ?
                                      <InputLabel className="labelArchivo" name={row[0].value} id={row[0].value}>
                                        {"Cargando ..."}
                                      </InputLabel>
                                      :
                                      nameAnexos && nameAnexos[row[0].value] ?
                                        <InputLabel className="labelArchivo" name={row[0].value} id={row[0].value}>
                                          <DescriptionIcon />
                                          {nameAnexos[row[0].value]}
                                        </InputLabel>
                                        :
                                        <FileUpload
                                          name={field.name}
                                          disabled={activeFormRya ? true : false}
                                          accept=".jpg, .png, .jpeg, .pdf, .gif, .BMP"
                                          // maxFileSize={tamanioFiles}
                                          customUpload
                                          uploadHandler={(event) =>
                                            handleUploadAnexo({ event, row })
                                          }
                                          onRemove={(event) => handleRemoveAnexo({ event, row })}
                                          chooseLabel={"Seleccionar archivo"}
                                          auto={true}
                                          multiple={false}
                                          mode={"basic"}
                                        />
                                  }
                                </TableCell>
                                {activeFormRya ?
                                  <TableCell align="right" className="actions-bandeja">
                                    {nameAnexos && nameAnexos[row[0].value] && nameAnexos[row[0].value].includes("chargedFileProsses") ?

                                      <InputLabel className="labelArchivo" name={row[0].value} id={row[0].value}>
                                        {"Cargando ..."}
                                      </InputLabel>
                                      :
                                      <React.Fragment>
                                        <Button
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"buttonAddInth"}
                                          startIcon={<OpenInBrowserIcon />}
                                          onClick={(event) => handleSeeAnexo({ event, row })}
                                        >
                                          {"Ver"}
                                        </Button>

                                        <FileUpload
                                          name={field.name}
                                          disabled={activeFormRya ? false : true}
                                          accept=".jpg, .png, .jpeg, .pdf, .gif, .BMP"
                                          // maxFileSize={tamanioFiles}
                                          customUpload
                                          uploadHandler={(event) =>
                                            handleUploadAnexo({ event, row, rya: true })
                                          }
                                          onRemove={(event) => handleRemoveAnexo({ event, row })}
                                          chooseLabel={"Reemplazar archivo"}
                                          auto={true}
                                          multiple={false}
                                          mode={"basic"}
                                        />
                                      </React.Fragment>
                                    }
                                  </TableCell>
                                  :
                                  <TableCell align="right">
                                    <Button
                                      variant={field.variant}
                                      color={"secondary"}
                                      type={`${field.submitable ? "submit" : "button"}`}
                                      className={"buttonAddInth"}
                                      startIcon={<OpenInBrowserIcon />}
                                      onClick={(event) => handleSeeAnexo({ event, row })}
                                    >
                                      {"Ver"}
                                    </Button>
                                    {/* </TableCell>
                                    <TableCell align="right"> */}
                                    <Button
                                      variant={field.variant}
                                      color={"secondary"}
                                      type={`${field.submitable ? "submit" : "button"}`}
                                      className={"buttonAddInth"}
                                      startIcon={<DeleteIcon />}
                                      //href={row[1]}
                                      onClick={(event) => handleRemoveAnexo({ event, row })}
                                    >
                                      {"Eliminar"}
                                    </Button>
                                  </TableCell>}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  ) : field.typeForm === "table3" ? (
                    <div>
                      {/* <div>{console.log(dynamicOptions)}</div> */}
                      <h3>{field.placeholder}</h3>
                      <TableContainer component={Paper} className="tableInth">
                        <Table
                          className={"classes.table"}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              {field.rows.map((campo) => (
                                <TableCell align="right">{campo}</TableCell>
                              ))}
                              {<TableCell align="right">{"   "}</TableCell>}
                            </TableRow>
                          </TableHead>
                          <TableBody>

                            {field.options?.map((row, position) => (

                              <TableRow >
                                {row?.map((campo, index) => (
                                  index === 0 ? (campo.rnec === true || campo.rnec === false) ?
                                    <TableCell align="right" className="cell-Valid-rnec">

                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checkedIcon={campo.rnec ? <CheckCircleIcon className="sucess-rnec" /> : <RemoveCircleIcon className="fail-rnec" />}
                                            checked={true}
                                          />
                                        }
                                        label={field.placeholder}
                                      />
                                    </TableCell>
                                    :
                                    <React.Fragment>
                                      <TableCell align="right">{"   "}</TableCell>
                                    </React.Fragment>
                                    : <TableCell align="right">{campo.label}</TableCell>

                                ))}
                                {activeFormRya && row[0] && row[0].rnec ?
                                  <React.Fragment>
                                    <TableCell align="right">{"   "}</TableCell>
                                  </React.Fragment>
                                  :
                                  <TableCell align="right">
                                    <ButtonGroup color="primary" className="button-contact-company">
                                      {field.name && field.name !== "tableWorkers" && (
                                        <IconButton
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"contact-company edit"}
                                          size="large"
                                          onClick={(event) => field.row({ event, position, row, field: { placeholder: "Editar" }, bandeja: activeFormRya })}
                                        >
                                          <EditIcon />
                                        </IconButton>)}
                                      {activeFormRya ? "" :
                                        <IconButton
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"contact-company delete"}
                                          size="large"
                                          onClick={(event) => field.row({ event, row, field: { placeholder: "Eliminar" }, bandeja: activeFormRya })}
                                        >
                                          <DeleteForeverIcon />
                                        </IconButton>
                                      }

                                    </ButtonGroup>
                                  </TableCell>
                                }

                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  ) : field.typeForm === "array" ? (
                    <FieldArray
                      validations={validations}
                      addLabel={field.addLabel}
                      removeLabel={field.removeLabel}
                      subitems={field.fields}
                      invalid={invalid}
                      name={field.name}
                      label={field.label}
                      fieldtitle={field.fieldtitle}
                      component={renderComponent}
                      dynamicOptions={dynamicOptions}
                      changeComponentId={changeComponentId}
                      tamanioFiles={tamanioFiles}
                      formName={formName}
                      disabled={field.disabled}
                      dynamicDisable={dynamicDisable}
                      activeFormRya={activeFormRya}
                      validRnecRepLegal={validRnecRepLegal}
                      editInfoFromBandeja={editInfoFromBandeja}
                      modalDireccion={modalDireccion}

                    />
                  ) : field.typeForm === "section" ? (
                    <React.Fragment>
                      {activeFormRya && !editInfoFromBandeja && field.name.includes("datospersonaladmin") ? "" :
                        <div className={`section-container ${field.hidden ? "no-visible" : ""}`}>

                          <FormSection name={field.name}>
                            <MaterialUiForm
                              sectionTitle={field.label}
                              label={<InputLabel>{field.placeholder}</InputLabel>}
                              submitable={false}
                              items={field.fields}
                              className="field-child"
                              member={member}
                              dynamicOptions={dynamicOptions}
                              changeComponentId={changeComponentId}
                              tamanioFiles={tamanioFiles}
                              validations={validations}
                              invalid={invalid}
                              dynamicDisable={dynamicDisable}
                              activeFormRya={activeFormRya}
                              validRnecRepLegal={validRnecRepLegal}
                              editInfoFromBandeja={editInfoFromBandeja}
                              formName={formName}
                              modalDireccion={modalDireccion}
                              handleUploadAnexo={handleUploadAnexo}
                              handleRemoveAnexo={handleRemoveAnexo}
                              handleSeeAnexo={handleSeeAnexo}
                              nameAnexos={nameAnexos}
                              newEstado={newEstado}
                            />
                          </FormSection>

                        </div>

                      }
                    </React.Fragment>
                  ) : field.typeForm === "file" ? (
                    <React.Fragment>
                      {field.tooltip && (
                        <LightTooltip
                          className="form-tooltip"
                          title={field.tooltip}
                          aria-label="add"
                        >
                          <HelpIcon />
                        </LightTooltip>
                      )}
                      <label className="label-name">
                        <span className="content-name">{field.label}</span>
                      </label>
                      <FormControl>

                        {nameAnexos && nameAnexos[field.name] && nameAnexos[field.name].includes("chargedFileProsses") ?
                          <InputLabel className="labelArchivo" name={field.name} id={field.name}>
                            {"Cargando ..."}
                          </InputLabel>
                          :
                          <FileUpload
                            name={field.name}
                            disabled={field.disabled}
                            accept={field.accept ? field.accept : ".jpg, .png, .jpeg, .pdf, .doc, .odt, .docx, .ods, .xls, .txt"}
                            maxFileSize={
                              field.maxFileSize ? field.maxFileSize : 2000000
                            }
                            // onUpload={(event) =>
                            //   field.handleRemove({ event, fileData })
                            // }
                            invalidFileSizeMessageDetail={''}
                            invalidFileSizeMessageSummary={'El Tamaño del archivo supera el máximo permitido 2MB.\nRealice los ajustes correspondientes  y vuelva a intentarlo'}
                            customUpload
                            uploadHandler={(event) =>
                              field.handleUpload({ event, fileData })
                            }
                            onRemove={(event) => field.handleRemove({ event, fileData })}
                            chooseLabel={field.placeholder}
                            auto={field.auto}
                            multiple={field.multiple}
                            mode={field.mode ? "advanced" : "basic"}
                          />
                        }
                      </FormControl>
                    </React.Fragment>
                  )
                    : field.typeForm === "fileA" ? (
                      <React.Fragment>
                        {field.tooltip && (
                          <Tooltip
                            className="form-tooltip"
                            title={field.tooltip}
                            aria-label="add"
                          >
                            <HelpIcon />
                          </Tooltip>
                        )}
                        <label className="label-name">
                          <span className="content-name">{field.label}</span>
                        </label>
                        <FormControl>
                          <FileUpload
                            name={field.name}
                            disabled={field.disabled}
                            accept=".jpg, .png, .jpeg, .pdf, .doc, .odt, .docx, .ods, .xls, .txt"
                            maxFileSize={
                              field.maxFileSize ? field.maxFileSize : 7000000
                            }

                            customUpload
                            uploadHandler={(event) =>
                              field.handleUpload({ event, fileData })
                            }
                            onRemove={(event) => handleRemove({ event, fileData })}
                            chooseLabel={field.placeholder}
                            auto={field.auto}
                            multiple={field.multiple}
                            mode={field.mode ? "advanced" : "basic"}
                            onUpload={true}
                          />
                          <div className={`table-upload" ${field.options.length > 0 ? "" : "no-visible"
                            }`} >

                            <TableContainer component={Paper} className={"tableUp"}>
                              <Table
                                className={"classes.table"}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="right">{"Archivos cargados"}</TableCell>
                                    <TableCell align="right">{" "}</TableCell>
                                    <TableCell align="right">{" "}</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {field.options.map((row) => (

                                    <TableRow >
                                      <TableCell align="right">{row[0]}</TableCell>
                                      <TableCell align="right">
                                        <Button
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"buttonAddInth"}
                                          startIcon={<GetAppIcon />}
                                          onClick={() => window.open(row[1], "_blank")}
                                        >
                                          {"Descargar"}
                                        </Button>
                                      </TableCell>
                                      <TableCell align="right">
                                        <Button
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"buttonAddInth"}
                                          startIcon={<DeleteIcon />}
                                          //href={row[1]}
                                          onClick={(event) => deleteAnexo({ field, row })}
                                        >
                                          {"Eliminar"}
                                        </Button>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </FormControl>
                      </React.Fragment>
                    ) : field.typeForm === "fileF" ? (
                      <React.Fragment>
                        {field.tooltip && (
                          <Tooltip
                            className="form-tooltip"
                            title={field.tooltip}
                            aria-label="add"
                          >
                            <HelpIcon />
                          </Tooltip>
                        )}
                        <label className="label-name">
                          <span className="content-name">{field.label}</span>
                        </label>
                        <FormControl>
                          <FileUpload
                            name={specialName}
                            disabled={field.disabled ? true : false}
                            accept=".jpg, .png, .jpeg"
                            maxFileSize={
                              field.maxFileSize ? field.maxFileSize : 7000000
                            }
                            onUpload={(event) =>
                              field.handleRemoveF({ event, fileData, name: specialName })
                            }
                            customUpload
                            uploadHandler={(event) =>
                              field.handleUploadF({ event, fileData, name: specialName })
                            }
                            onRemove={(event) => field.handleRemoveF({ event, fileData, name: specialName })}
                            chooseLabel={field.placeholder}
                            auto={field.auto}
                            multiple={field.multiple}
                            mode={field.mode ? "advanced" : "basic"}
                          />
                          <div className={`table-upload-firma ${field.options.length > 0 ? "" : "no-visible"
                            }`} >

                            <TableContainer component={Paper} className={"tableFirma"} name={specialName}>
                              <Table
                                className={"classes.table"}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="right">{"Firma cargada"}</TableCell>
                                    <TableCell align="right">{" "}</TableCell>
                                    <TableCell align="right">{" "}</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {field.options.map((row) => (

                                    <TableRow >
                                      <TableCell align="right">{row[0]}</TableCell>
                                      <TableCell align="right">
                                        <Button
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"buttonAddInth"}
                                          startIcon={<VisibilityIcon />}
                                          onClick={() => window.open(row[1], "_blank")}
                                        />
                                      </TableCell>
                                      <TableCell align="right">
                                        <Button
                                          variant={field.variant}
                                          color={"secondary"}
                                          type={`${field.submitable ? "submit" : "button"}`}
                                          className={"buttonAddInth"}
                                          startIcon={<DeleteIcon />}
                                          //href={row[1]}
                                          onClick={(event) => deleteFirma({ specialName, row })}
                                        />

                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </FormControl>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {field.tooltip && (
                          <LightTooltip
                            className="form-tooltip"
                            title={field.tooltip}
                            aria-label="add"
                          >
                            <HelpIcon />
                          </LightTooltip>
                        )}
                        <label className="label-name">
                          <span className="content-name">{field.label}</span>
                        </label>
                        <Field
                          name={specialName}
                          component={renderComponent}
                          label={field.type === "date" ? "" : field.label}
                          options={field.options}
                          multiline={field.multiline}
                          rows={field.rows}
                          key={`field-${j}`}
                          subitems={field.fields}
                          type={field.type}
                          maxLength={field.maxLength}
                          minLength={field.minLength}
                          dataTitle={field.dataTitle}
                          //disabled={field.disabled}
                          placeholder={field.placeholder}
                          disabled={
                            hiddenClose &&
                              specialName === hiddenClose.val &&
                              hiddenClose.state === true
                              ? false
                              : field.disabled
                          }
                        //className={field.type === "date" ? "datepicker" : ""}
                        >
                          {field.typeForm === "select" && (
                            <option key={`option-${j}`} value=""></option>
                          )}
                          {field.options &&
                            field.options.map((item, k) => {
                              if (field.typeForm === "radios") {
                                return (
                                  <Radio
                                    key={`radio-${k}`}
                                    value={item.value}
                                    label={item.label}
                                    checked={
                                      item.value === activateRadio ? true : false
                                    }
                                  >
                                    {item.label}
                                  </Radio>
                                );
                              } else if (field.typeForm === "select") {
                                return (
                                  <option key={`s-option-${k}`} value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              }
                            })}
                        </Field>
                      </React.Fragment>
                    )}
              </div>
            );
          })}
        </div>
      </React.Fragment >
    );
  }
}
